<template>
    <div class="flex gap-4 px-2 py-4 hover:bg-gray-300">
        <div class="text-2xl handle draggable">&#9776;</div>
        <div class="flex flex-col gap-2 flex-1">
            <div class="flex items-center level-heading">
                <div class="w-32 text-2xl flex-1 truncate ...">{{level.name}}</div>
                <div v-if="!isEventArchived" class="flex gap-2 mr-px flex-shrink-0">
                    <button @click="$emit('set-edit-level', level)" class="btn-blue-outline btn-xs">Edit</button>
                    <button @click="$emit('remove-sponsor-level', level)" class="btn-red-outline btn-xs">&#x2715;</button>
                </div>
            </div>
            <div v-if="levelHasLimitedSponsors(level)" class="flex gap-4 h-4 items-center">
              <div class="progress-bar">
                <span class="progress-bar-fill" :style="{width: `${percentFilled(level)}%`}"></span>
              </div>
              <div class="text-xs font-semibold text-gray-600 flex-shrink-0">{{ existingSponsorsCount }} / {{ totalPossibleSponsors(level) }} Sponsors</div>
            </div>
            <div v-else class="flex justify-between gap-4 h-4 items-center">
              <div>
                <span class="text-xs font-semibold text-gray-600">Unlimited</span>
              </div>
              <div class="h-4 flex items-center text-xs font-semibold text-gray-600 justify-end">{{existingSponsorsCount }} Sponsors</div>
            </div>
        </div>
    </div>
  </template>

<script>
import {SPONSOR_NUMBER_TYPES} from './utils'

export default {
  props: {
    existingSponsorsCount: {
      type: Number,
      default: 0
    },
    isEventArchived: {
      type: Boolean,
      default: false
    },
    level: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    levelHasLimitedSponsors (level) {
      return level.sponsorNumberType === SPONSOR_NUMBER_TYPES.LIMITED
    },
    percentFilled (level) {
      return (this.existingSponsorsCount / this.totalPossibleSponsors(level)) * 100
    },
    totalPossibleSponsors (level) {
      if (level.modifiersEnabled) {
        return level.sponsorNumber * level.modifiers.length
      } else {
        return level.sponsorNumber
      }
    }
  }
}
</script>

  <style>
  .draggable:hover {
    cursor: grab;
  }
  .level-heading {
    padding-top: 3px;
  }
  .progress-bar {
  width: 100%;
  background-color: #e2e8f0;
  border-radius: 3px;

}

.progress-bar-fill {
  display: block;
  height: 8px;
  background-color: #4299e1;
  border-radius: 3px;

  transition: width 500ms ease-in-out;
}
  </style>
